/* eslint-disable no-unused-vars */

// Constants
import { SAMPLE_EULA } from '../constants/sampleEula';
import axios from '../axios-interceptor';
import { environment } from '../environments/environment';
import { toaster } from '../components/common/Toaster';
import { checkIfServerError } from './AuthActionsAPI';
import { Constants } from '../constants/constants';


const baseURL = environment.baseURL;
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
let existingUser = false;

export function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

export function isRandomFailure() {
    return false;
}

/**
 * Example implementation of [[RegistrationUIActions]] to start with during development.
 *
 * Registration Actions to be performed based on the user's actions. The application will create appropriate actions
 * (often API calls, local network storage, credential updates, etc.) based on the actionable needs of the user.
 */
export const ProjectRegistrationUIActions = () => ({
    /**
     * The user wants to complete an action but must first accept the EULA.
     * The application should retrieve an application-specific EULA for the user.
     *
     * @param language  The i18n language the user is requesting for the EULA text.
     *
     * @returns Resolve with EULA, otherwise reject with an error message.
     */
    loadEula: async (language) => {

        return SAMPLE_EULA;
    },

    /**
     * The user entered their email address and accepted the EULA.
     * The API should now send them an email with the validation code.
     *
     * @param email  Email for the registering user.
     *
     * @returns Resolve when the server accepted the request.
     */
    requestRegistrationCode: async (email) => {
        const formData = { email: email }
        // Suppress generic toaster for this request - we'll display error inline
        try {
            const response = await axios.post(`${baseURL}/security/account/create`, formData, { showGenericToaster: false });
            const data = response?.data;
            existingUser = data?.data != undefined ? !data?.data?.newUser : false;
            window.sessionStorage.setItem('validaityCode', data?.data?.Code);
            // Success - return to allow workflow to proceed
            return;
        } catch (error) {
            // Handle 409 Conflict (account already exists) or other errors
            console.error('Account creation error:', error);
            
            // Check if it's a 409 Conflict (account already exists)
            if (error?.response?.status === 409) {
                throw new Error('An account with this email address already exists. Please use a different email or try logging in.');
            }
            
            // Check for other HTTP status codes
            if (error?.response?.status === 400) {
                const errorMessage = error?.response?.data?.message || 'Invalid email address format';
                throw new Error(errorMessage);
            }
            
            // Handle network errors
            if (!error?.response) {
                throw new Error('Network error. Please check your connection and try again.');
            }
            
            // Generic error with backend message if available
            const backendMessage = error?.response?.data?.message;
            if (backendMessage) {
                throw new Error(backendMessage);
            }
            
            // Final fallback
            throw new Error('Failed to send registration code. Please try again.');
        }
    },

    /**
     * The user has tapped on an email link inviting them to register with the application.
     * The application should validate the code provided by the link.
     *
     * @param validationCode  Registration code provided from the link.
     * @param validationEmail  Email provided from the invitation email link (optional) `?email=addr%40domain.com`.
     *
     * @returns Resolves when the code is valid. True if registration is complete, False if account information is needed.
     *          If the code is not valid a rejection will occur with an error message.
     */
    validateUserRegistrationRequest: async (validationCode, validationEmail) => {
        await sleep(0);

        if (isRandomFailure()) {
            throw new Error('Sorry, there was a problem sending your request.');
        }
        return {
            codeValid: true
        }
    },
    /**
     * The user has been invited to register and has entered the necessary account and
     * password information.
     * The application should now complete the registration process given the user's data.
     *
     * Note: Upon resolution, the user will be brought back to the Login screen.
     *
     * @param userData  Account details and password entered by the user.
     * @param validationCode  Registration code provided from the invitation email link.
     * @param validationEmail  Email provided from the invitation email link (optional) `?email=addr%40domain.com`.
     *
     * @returns Resolve when account creation succeeds, otherwise reject with an error message.
     */
    completeRegistration: async (userData, validationCode, validationEmail) => {
        const {company,code,emailAddress,password,role,utility} = userData;
        const {firstName,lastName,phone, region,country } = userData?.customScreenOne;
        const requestedProducts = []; const licenseVersion = "1";
        const userInfo = { email: emailAddress, organizationName: company };
        const formData = {
            code: code,
            email: emailAddress,
            display_name: firstName + ' ' + lastName,
            first_name: firstName,
            password,
            country,
            region_states: region,
            company_name: company,
            electric_utility: utility,
            last_name: lastName,
            job_title: role,
            phone_number: phone,
            licenseVersion,
            requestedProducts,
            existingUser,
        };
        await axios.post(`${baseURL}/security/account/validate`, formData)
        .then((response) => {
            // Success
            response.data.data = {email: 'abc@a.com'}
            window?.navigator?.language?.includes(Constants?.frenchLanguage) ? toaster(Constants.frenchMessageForRegistrationComplete, 'Success') : toaster(Constants.englishMessageForRgisterationComplete, 'Success');
            ;
        })
        .catch((error) => {
            // Error
            if(checkIfServerError(error)){
                toaster(`${error.message}`);
            }
            if (error && error.hasOwnProperty('message')) {
                if (window?.navigator?.language?.includes(Constants?.frenchLanguage)) {
                    throw new Error(Constants.frenchMessageForInvalidCode);
                } else {
                    throw new Error(Constants.englishMessageForInvalidCode);
                }
            } else {
                throw new Error('Something went wrong! Please contact administrator.');
            }
        });
        return userInfo;
    },
});
